import { Button } from '@casavo/base-ui'
import { ColorsPalette } from '@casavo/base-ui/types/foundations/colors'
import cn from 'classnames'

import Close from '@/components/Icon/Close'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { FavouriteSearchOrigin } from '@/lib/api-gluglu-open'
import { backgroundColor, flexColumnSpaceBetween } from '@/shared-styles/styles.css'
import { zIndex } from '@/utils/css-utils'
import { handleNewListingsAlertClick } from '@/utils/tracking/eventsHandlers'

type Props = {
  backToInitialScroll?: boolean
  bgColor?: ColorsPalette
  className?: string
  origin: FavouriteSearchOrigin
}

export const ContentWrapper: React.FC<Props> = ({ backToInitialScroll, bgColor, children, className, origin }) => {
  const { closeModal } = useModal()
  return (
    <div className={cn(flexColumnSpaceBetween, backgroundColor[bgColor], className)}>
      <Button
        ariaLabel="Close"
        className={sprinkles({ position: 'absolute', right: 'm', top: 'm', zIndex: zIndex('modalContent') })}
        data-testid="save-search-close-modal"
        Icon={(props) => <Close {...props} />}
        shapeVariant="round"
        styleVariant="tertiary"
        onClick={() => {
          closeModal({ shouldBackToInitialScroll: backToInitialScroll })
          handleNewListingsAlertClick('CloseModal', origin === 'SEARCH_RESULTS' ? 'ListingsFeed' : 'ListingDetail')
        }}
      />
      {children}
    </div>
  )
}
